import FallbackHero from './fallback-hero'
import FallbackHeroQuery from './fallback-hero.query'

export { FallbackHeroQuery }

export default FallbackHero
